(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-hero"] && !Shopify.designMode) return;
  try {
    
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initSnow(root) {
    const canvas = root.querySelector('[data-sb-snow]');
    if (!canvas) return;
    const isMobile = window.matchMedia('(max-width: 999px)').matches;
    if (isMobile && root.dataset.snowMobile !== 'true') {
      canvas.remove();
      return;
    }
    let count = parseInt(root.dataset.snow, 10) || 0;
    if (isMobile) count = Math.round(count * 0.6);
    if (count === 0 || reduceMotion.matches) {
      canvas.remove();
      return;
    }
    const ctx = canvas.getContext('2d');
    let w = 0;
    let h = 0;
    let flakes = [];
    let running = false;
    let raf = null;

    function makeFlake(randomY) {
      const r = 0.8 + Math.random() * 2.2;
      return {
        x: Math.random() * w,
        y: randomY ? Math.random() * h : -r * 2,
        r: r,
        vy: 0.25 + r * 0.25,
        drift: (Math.random() - 0.5) * 0.4,
        phase: Math.random() * Math.PI * 2,
        a: 0.35 + Math.random() * 0.5
      };
    }

    function resize() {
      const rect = canvas.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = rect.width;
      h = rect.height;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      flakes = Array.from({ length: count }, () => makeFlake(true));
    }

    function frame(t) {
      if (!running) return;
      ctx.clearRect(0, 0, w, h);
      for (let i = 0; i < flakes.length; i++) {
        const f = flakes[i];
        f.y += f.vy;
        f.x += f.drift + Math.sin(t / 1400 + f.phase) * 0.3;
        if (f.y > h + f.r * 2 || f.x < -10 || f.x > w + 10) {
          flakes[i] = makeFlake(false);
          continue;
        }
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(244, 234, 213, ' + f.a + ')';
        ctx.fill();
      }
      raf = requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      running = true;
      raf = requestAnimationFrame(frame);
    }

    function stop() {
      running = false;
      if (raf) cancelAnimationFrame(raf);
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? start() : stop()));
    });
    io.observe(root);
    window.addEventListener('resize', resize, { passive: true });
    resize();
  }

  function initParallax(root) {
    if (root.dataset.parallax !== 'true' || reduceMotion.matches) return;
    let ticking = false;

    function update() {
      ticking = false;
      const rect = root.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, -rect.top / rect.height));
      root.style.setProperty('--sb-bg-y', (progress * rect.height * 0.3).toFixed(1) + 'px');
      root.style.setProperty('--sb-group-shift', (progress * rect.height * 0.12).toFixed(1) + 'px');
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-sb-hero]').forEach((root) => {
      if (root.dataset.sbInit) return;
      root.dataset.sbInit = 'true';
      initSnow(root);
      initParallax(root);
    });
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);

  } catch(e) { console.error(e); }
})();
})();
